import { SVGProps } from 'react';

export const LocationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10 7.375a3.125 3.125 0 1 0 0 6.25 3.125 3.125 0 0 0 0-6.25Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 1.542a.625.625 0 0 1 .625.625v1.068a7.293 7.293 0 0 1 6.64 6.64h1.068a.625.625 0 0 1 0 1.25h-1.068a7.293 7.293 0 0 1-6.64 6.64v1.068a.625.625 0 1 1-1.25 0v-1.068a7.293 7.293 0 0 1-6.64-6.64H1.667a.625.625 0 1 1 0-1.25h1.068a7.293 7.293 0 0 1 6.64-6.64V2.167A.625.625 0 0 1 10 1.542ZM3.958 10.5a6.042 6.042 0 1 0 12.084 0 6.042 6.042 0 0 0-12.084 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export default LocationIcon;
